
<script setup lang="ts">
import DataView from 'primevue/dataview';
import {useModyApi} from "~/middelware/ModyApi";
import {BlogArticle} from "~/utils/BlogArticle";
import {useRouter} from "vue-router";

const api = useModyApi()
let blogArticles = ref<BlogArticle[]>([])
const router = useRouter()
const totalRecords = ref(0)
const page = ref(0)

onMounted(async ()=>{
  await loadData()
})

watch(page,async ()=>{
  await loadData()
})

async function loadData(){
  let response = (await api.getFeaturedBlogArticles(page.value,10,""))
  blogArticles.value = response.blogArticles
  totalRecords.value = response.totalRecords
}

</script>

<template>
  <div>
    <PublicPageIntro
      eyebrow="Wissen & Praxis"
      title="Mody Blog"
      description="Tipps, Einblicke und praktische Orientierung rund um Veranstaltungstechnik, Planung und gelungene Events."
      compact
    />
    <BlogSideMenu></BlogSideMenu>
    <BlogArticleList :blog-articles="blogArticles" v-model="page" :totalRecords="totalRecords" title="Letzte Beiträge" ></BlogArticleList>
  </div>
</template>
